import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import FormattedInputField from '../sharedComponents/formattedInputField.component.jsx'
import GlobalHelper from '../common/GlobalHelper.jsx'
import $ from 'jquery'
import FeeService from '../state/fee/FeeService'
import { isError } from "../state/helpers/Error";
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import ActionButton from '../common/button/actionbutton.component.jsx'

const messages = defineMessages({
    "quote.set_fee_modal.none_option": {
        id: 'quote.set_fee_modal.none_option',
        defaultMessage: 'None',
    },
})
class FeeQuote extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            feeId: this.props.feeId || '',
            feeRate: '',
            billingMethod: this.props.billingMethod || '',
            endPoint: this.getEndPoint(this.props),
            loading: true,
            fees: [],
            applyingFee: false,
        }

        this.onClose = this.props.onClose
        this.handleFeeIdChange = this.handleFeeIdChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.applyFee = this.applyFee.bind(this)
        this.onValueChange = this.onValueChange.bind(this)
    }

    getEndPoint(props) {
        if (props.mainObject) {
            return '/' + props.mainObject + '/' + props.objectId
        }
        return props.invoiceId ? '/invoices/' + props.invoiceId : '/quotes/' + props.quoteId
    }

    applyFee(event) {
        this.setState({ applyingFee: true })
        let val = []
        if (this.state.feeId) {
            let rate = this.state.feeRate
            if (!rate) {
                let selectedFee = this.state.fees.find(f => f.id == target.value)
                rate = selectedFee ? selectedFee.attributes.rate : ""
            }
            val = [{ "feeId": this.state.feeId, "feeRate": rate }]
        }
        event.preventDefault()
        let field = "feeIds"
        switch (this.state.billingMethod) {
            case 'monthly':
                field = "monthlyFeeIds"
                break
            case 'yearly':
                field = "yearlyFeeIds"
                break
        }
        AppContext.getApiClient().patch(this.state.endPoint, {
            [field]: val,
        }).then(_ => {
            this.setState({ applyingFee: false })
            this.closeModals(event)
        })
    }

    handleFeeIdChange(event) {
        const target = event.target;
        let selectedFee = this.state.fees.find(f => f.id == target.value)
        let rate = selectedFee ? selectedFee.attributes.rate : ""
        this.setState({
            feeId: target.value,
            feeRate: rate,
        });
    }

    async componentDidMount() {
        $('#applyFeeModal').modal('show')
        const r = await FeeService.Get()
        if (!isError(r)) {
            let selectedFee = r.find(f => f.id == this.state.feeId)
            let rate = selectedFee ? selectedFee.attributes.rate : ""
            this.setState({
                fees: r,
                feeRate: rate,
                loading: false,
            })
        }

    }


    closeModals(event) {
        event.preventDefault()
        $('#applyFeeModal').modal('hide')
        this.onClose()
    }

    onValueChange(event) {
        this.setState({
            feeRate: event
        });
    }

    renderFeeSelect() {
        let displayRate = () => {
            let selectedFee = this.state.fees.find(f => f.id == this.state.feeId)
            let rateType = selectedFee ? selectedFee.attributes.rateType : ''
            let { feeLabel, inputGroupText } = GlobalHelper.GetLabelAndSign(rateType)
            return selectedFee && <div className="row">
                <label className="col-2 col-form-label text-align-right">
                    {feeLabel}
                </label>
                <div className="col-8 input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{inputGroupText}</span>
                    </div>
                    <FormattedInputField
                        name="rate"
                        id={'rate'}
                        type="text"
                        className="form-control"
                        placeholder={GlobalHelper.applyLocaleDecimal("5.5", AppContext.getLocale().getLanguage())}
                        valueType="money"
                        value={this.state.feeRate}
                        onValueChange={(event) => this.onValueChange(event)}
                    />
                </div>
            </div>

        }

        return <div>
            <div className="row mb-2">
                <label className="col-2 col-form-label text-align-right" >
                    <FormattedMessage
                        id="fee.form.edit.fee_name_label"
                        defaultMessage="Fee"
                    />
                </label>
                <div className="col-8">
                    <select value={this.state.feeId}
                        className="form-control w-100"
                        onChange={this.handleFeeIdChange}>
                        <option value={''}>
                            {this.props.intl.formatMessage(messages['quote.set_fee_modal.none_option'])}
                        </option>
                        {this.state.fees.map(t => <option key={t.id} value={t.id}>
                            {t.attributes.name}
                        </option>)}
                    </select>
                </div>
            </div>
            {displayRate()}
        </div>
    }

    render() {
        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="applyFeeModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="quote.set_fee_modal.title"
                                        defaultMessage="Fee"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {this.state.loading ? <LoadingSpinner /> :
                                    <div className="container-fluid">
                                        <form className="form-inline d-flex justify-content-center">
                                            {this.renderFeeSelect()}
                                        </form>
                                    </div>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_fee_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <ActionButton type="button" className="btn btn-primary"
                                    disabled={this.state.feeRate == "" && this.state.feeId != ""}
                                    isLoading={this.state.applyingFee}
                                    onClick={this.applyFee}>
                                    <FormattedMessage
                                        id="quote.set_fee_modal.apply_fee_btn"
                                        defaultMessage="Apply Fee"
                                    />
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(FeeQuote)





// WEBPACK FOOTER //
// ./src/quote/fee.component.jsx